// src/reducers/transferReducers.js

import {
  TRANSFER_PRODUCT_STOCK_REQUEST,
  TRANSFER_PRODUCT_STOCK_SUCCESS,
  TRANSFER_PRODUCT_STOCK_FAIL,
  TRANSFER_PRODUCT_STOCK_RESET,
  TRANSFER_COMPONENT_STOCK_REQUEST,
  TRANSFER_COMPONENT_STOCK_SUCCESS,
  TRANSFER_COMPONENT_STOCK_FAIL,
  TRANSFER_COMPONENT_STOCK_RESET,
  CLEAR_TRANSFER_ERRORS,        // shared “clear errors” action
} from "../constants/productConstants";

const initialTransferState = {
  loading: false,
  success: false,
  transfer: null,    // the newly created transfer record
  error: null,
};

export function productTransferReducer(state = initialTransferState, action) {
  switch (action.type) {
    case TRANSFER_PRODUCT_STOCK_REQUEST:
      return { ...initialTransferState, loading: true };

    case TRANSFER_PRODUCT_STOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        transfer: action.payload,
      };

    case TRANSFER_PRODUCT_STOCK_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    case TRANSFER_PRODUCT_STOCK_RESET:
      return { ...initialTransferState };

    case CLEAR_TRANSFER_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
}

export function componentTransferReducer(state = initialTransferState, action) {
  switch (action.type) {
    case TRANSFER_COMPONENT_STOCK_REQUEST:
      return { ...initialTransferState, loading: true };

    case TRANSFER_COMPONENT_STOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        transfer: action.payload,
      };

    case TRANSFER_COMPONENT_STOCK_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    case TRANSFER_COMPONENT_STOCK_RESET:
      return { ...initialTransferState };

    case CLEAR_TRANSFER_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
}
